var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PublicityDetail7"},[_c('h3',[_vm._v("金融产品查询平台")]),_c('img',{attrs:{"src":require('../images/ic_publicity_detail7_1.jpg')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }